module.exports = __webpack_public_path__ + "img/banner-mobile.d8301d76.jpg";